"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _axios = _interopRequireDefault(require("axios"));

var _store_api = _interopRequireDefault(require("./store_api"));

var SourceApi =
/*#__PURE__*/
function (_StoreApi) {
  (0, _inherits2.default)(SourceApi, _StoreApi);

  /**
   * @constructor
   */
  function SourceApi(_ref) {
    var _this;

    var userTokenFactory = _ref.userTokenFactory,
        storeApiUrl = _ref.storeApiUrl,
        entityType = _ref.entityType;
    (0, _classCallCheck2.default)(this, SourceApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SourceApi).call(this, {
      userTokenFactory: userTokenFactory,
      storeApiUrl: storeApiUrl
    }));

    if (entityType) {
      _this.entityType = entityType;
    }

    return _this;
  }

  (0, _createClass2.default)(SourceApi, [{
    key: "getEntities",
    value: function () {
      var _getEntities = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(_ref2) {
        var _this2 = this;

        var entityType, type, headers;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                entityType = _ref2.entityType;
                type = entityType || this.entityType;
                _context.next = 4;
                return this.getHeaders();

              case 4:
                headers = _context.sent;
                return _context.abrupt("return", Promise.try(function () {
                  return _axios.default.get("".concat(_this2.storeApiUrl, "/api/sources/").concat(type), headers);
                }).then(function (response) {
                  return Promise.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getEntities(_x) {
        return _getEntities.apply(this, arguments);
      }

      return getEntities;
    }()
  }, {
    key: "getEntity",
    value: function () {
      var _getEntity = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(_ref3) {
        var _this3 = this;

        var entityType, id, type, headers;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                entityType = _ref3.entityType, id = _ref3.id;
                type = entityType || this.entityType;
                _context2.next = 4;
                return this.getHeaders();

              case 4:
                headers = _context2.sent;
                return _context2.abrupt("return", Promise.try(function () {
                  return _axios.default.get("".concat(_this3.storeApiUrl, "/api/sources/").concat(type, "/").concat(id), headers);
                }).then(function (response) {
                  return Promise.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getEntity(_x2) {
        return _getEntity.apply(this, arguments);
      }

      return getEntity;
    }()
  }, {
    key: "addEntity",
    value: function () {
      var _addEntity = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(_ref4, payload) {
        var _this4 = this;

        var entityType, type, headers;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                entityType = _ref4.entityType;
                type = entityType || this.entityType;
                _context3.next = 4;
                return this.getHeaders();

              case 4:
                headers = _context3.sent;
                return _context3.abrupt("return", Promise.try(function () {
                  return _axios.default.post("".concat(_this4.storeApiUrl, "/api/sources/").concat(type), payload, headers);
                }).then(function (response) {
                  return Promise.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function addEntity(_x3, _x4) {
        return _addEntity.apply(this, arguments);
      }

      return addEntity;
    }()
  }, {
    key: "patchEntityMeta",
    value: function () {
      var _patchEntityMeta = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref5, payload) {
        var _this5 = this;

        var entityType, id, type, headers;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                entityType = _ref5.entityType, id = _ref5.id;
                type = entityType || this.entityType;
                _context4.next = 4;
                return this.getHeaders();

              case 4:
                headers = _context4.sent;
                return _context4.abrupt("return", Promise.try(function () {
                  return _axios.default.patch("".concat(_this5.storeApiUrl, "/api/sources/").concat(type, "/").concat(id, "/meta"), payload, headers);
                }).then(function (response) {
                  return Promise.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function patchEntityMeta(_x5, _x6) {
        return _patchEntityMeta.apply(this, arguments);
      }

      return patchEntityMeta;
    }()
  }, {
    key: "deleteEntity",
    value: function () {
      var _deleteEntity = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(_ref6) {
        var _this6 = this;

        var entityType, id, type, headers;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                entityType = _ref6.entityType, id = _ref6.id;
                type = entityType || this.entityType;
                _context5.next = 4;
                return this.getHeaders();

              case 4:
                headers = _context5.sent;
                return _context5.abrupt("return", Promise.try(function () {
                  return _axios.default.delete("".concat(_this6.storeApiUrl, "/api/sources/").concat(type, "/").concat(id), headers);
                }).then(function (response) {
                  return Promise.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteEntity(_x7) {
        return _deleteEntity.apply(this, arguments);
      }

      return deleteEntity;
    }()
  }, {
    key: "getSource",
    value: function () {
      var _getSource = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(_ref7) {
        var _this7 = this;

        var entityType, id, sourceId, type, headers;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                entityType = _ref7.entityType, id = _ref7.id, sourceId = _ref7.sourceId;
                type = entityType || this.entityType;
                _context6.next = 4;
                return this.getHeaders();

              case 4:
                headers = _context6.sent;
                return _context6.abrupt("return", Promise.try(function () {
                  return _axios.default.get("".concat(_this7.storeApiUrl, "/api/sources/").concat(type, "/").concat(id, "/source/").concat(sourceId), headers);
                }).then(function (response) {
                  return Promise.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getSource(_x8) {
        return _getSource.apply(this, arguments);
      }

      return getSource;
    }()
  }, {
    key: "deleteSource",
    value: function () {
      var _deleteSource = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(_ref8) {
        var _this8 = this;

        var entityType, id, sourceId, type, headers;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                entityType = _ref8.entityType, id = _ref8.id, sourceId = _ref8.sourceId;
                type = entityType || this.entityType;
                _context7.next = 4;
                return this.getHeaders();

              case 4:
                headers = _context7.sent;
                return _context7.abrupt("return", Promise.try(function () {
                  return _axios.default.delete("".concat(_this8.storeApiUrl, "/api/sources/").concat(type, "/").concat(id, "/source/").concat(sourceId), headers);
                }).then(function (response) {
                  return Promise.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function deleteSource(_x9) {
        return _deleteSource.apply(this, arguments);
      }

      return deleteSource;
    }()
  }, {
    key: "patchSourceMeta",
    value: function () {
      var _patchSourceMeta = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(_ref9, payload) {
        var _this9 = this;

        var entityType, id, sourceId, type, headers;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                entityType = _ref9.entityType, id = _ref9.id, sourceId = _ref9.sourceId;
                type = entityType || this.entityType;
                _context8.next = 4;
                return this.getHeaders();

              case 4:
                headers = _context8.sent;
                return _context8.abrupt("return", Promise.try(function () {
                  return _axios.default.patch("".concat(_this9.storeApiUrl, "/api/sources/").concat(type, "/").concat(id, "/source/").concat(sourceId, "/meta"), payload, headers);
                }).then(function (response) {
                  return Promise.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function patchSourceMeta(_x10, _x11) {
        return _patchSourceMeta.apply(this, arguments);
      }

      return patchSourceMeta;
    }()
  }, {
    key: "forkSource",
    value: function () {
      var _forkSource = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(_ref10, payload) {
        var _this10 = this;

        var entityType, id, sourceId, type, headers;
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                entityType = _ref10.entityType, id = _ref10.id, sourceId = _ref10.sourceId;
                type = entityType || this.entityType;
                _context9.next = 4;
                return this.getHeaders();

              case 4:
                headers = _context9.sent;
                return _context9.abrupt("return", Promise.try(function () {
                  return _axios.default.post("".concat(_this10.storeApiUrl, "/api/sources/").concat(type, "/").concat(id, "/source/").concat(sourceId, "/fork"), payload, headers);
                }).then(function (response) {
                  return Promise.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function forkSource(_x12, _x13) {
        return _forkSource.apply(this, arguments);
      }

      return forkSource;
    }()
  }, {
    key: "setPublished",
    value: function () {
      var _setPublished = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(_ref11, payload) {
        var _this11 = this;

        var entityType, id, sourceId, type, headers;
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                entityType = _ref11.entityType, id = _ref11.id, sourceId = _ref11.sourceId;
                type = entityType || this.entityType;
                _context10.next = 4;
                return this.getHeaders();

              case 4:
                headers = _context10.sent;
                return _context10.abrupt("return", Promise.try(function () {
                  return _axios.default.post("".concat(_this11.storeApiUrl, "/api/sources/").concat(type, "/").concat(id, "/source/").concat(sourceId, "/published"), payload, headers);
                }).then(function (response) {
                  return Promise.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function setPublished(_x14, _x15) {
        return _setPublished.apply(this, arguments);
      }

      return setPublished;
    }()
  }, {
    key: "getRevision",
    value: function () {
      var _getRevision = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(_ref12) {
        var _this12 = this;

        var entityType, id, sourceId, revisionId, type, headers;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                entityType = _ref12.entityType, id = _ref12.id, sourceId = _ref12.sourceId, revisionId = _ref12.revisionId;
                type = entityType || this.entityType;
                _context11.next = 4;
                return this.getHeaders();

              case 4:
                headers = _context11.sent;
                return _context11.abrupt("return", Promise.try(function () {
                  return _axios.default.get("".concat(_this12.storeApiUrl, "/api/sources/").concat(type, "/").concat(id, "/source/").concat(sourceId, "/revision/").concat(revisionId), headers);
                }).then(function (response) {
                  return Promise.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getRevision(_x16) {
        return _getRevision.apply(this, arguments);
      }

      return getRevision;
    }()
  }, {
    key: "addRevision",
    value: function () {
      var _addRevision = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12(_ref13, payload) {
        var _this13 = this;

        var entityType, id, sourceId, type, headers;
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                entityType = _ref13.entityType, id = _ref13.id, sourceId = _ref13.sourceId;
                type = entityType || this.entityType;
                _context12.next = 4;
                return this.getHeaders();

              case 4:
                headers = _context12.sent;
                return _context12.abrupt("return", Promise.try(function () {
                  return _axios.default.post("".concat(_this13.storeApiUrl, "/api/sources/").concat(type, "/").concat(id, "/source/").concat(sourceId, "/revision"), payload, headers);
                }).then(function (response) {
                  return Promise.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function addRevision(_x17, _x18) {
        return _addRevision.apply(this, arguments);
      }

      return addRevision;
    }()
  }, {
    key: "setSandbox",
    value: function () {
      var _setSandbox = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13(_ref14, payload) {
        var _this14 = this;

        var entityType, id, sourceId, revisionId, type, headers;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                entityType = _ref14.entityType, id = _ref14.id, sourceId = _ref14.sourceId, revisionId = _ref14.revisionId;
                type = entityType || this.entityType;
                _context13.next = 4;
                return this.getHeaders();

              case 4:
                headers = _context13.sent;
                return _context13.abrupt("return", Promise.try(function () {
                  return _axios.default.post("".concat(_this14.storeApiUrl, "/api/sources/").concat(type, "/").concat(id, "/source/").concat(sourceId, "/revision/").concat(revisionId, "/sandbox"), payload, headers);
                }).then(function (response) {
                  return Promise.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function setSandbox(_x19, _x20) {
        return _setSandbox.apply(this, arguments);
      }

      return setSandbox;
    }()
  }]);
  return SourceApi;
}(_store_api.default);

var _default = SourceApi;
exports.default = _default;